import type { FlexProps } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/react';

export const Empty = (props: FlexProps) => {
  return (
    <Flex alignItems="center" justifyContent="center" h="400px" {...props}>
      <Text textStyle="body2" color="text.secondary">
        No Data
      </Text>
    </Flex>
  );
};
